import { defaultTheme } from '@cbhq/cds-web/themes/defaultTheme';

// Create a custom theme that extends the default CDS theme with our font configuration
export const customTheme = {
  ...defaultTheme,
  fontFamily: {
    // Display fonts use Base Sans (using CSS variable from Next.js localFont)
    display1: 'var(--defaultFont-sans)',
    display2: 'var(--defaultFont-sans)',
    display3: 'var(--defaultFont-sans)',

    // Title fonts use Base Sans
    title1: 'var(--defaultFont-sans)',
    title2: 'var(--defaultFont-sans)',
    title3: 'var(--defaultFont-sans)',
    title4: 'var(--defaultFont-sans)',

    // Body/UI fonts use Inter (using CSS variable from Next.js localFont)
    headline: 'var(--inter-font)',
    body: 'var(--inter-font)',
    label1: 'var(--inter-font)',
    label2: 'var(--inter-font)',
    caption: 'var(--inter-font)',
    legal: 'var(--inter-font)',
  },
  space: {
    '0': 0,
    '0.25': 2,
    '0.5': 4,
    '0.75': 6,
    '1': 8,
    '1.5': 10,
    '2': 16,
    '3': 20,
    '4': 24,
    '5': 28,
    '6': 32,
    '7': 36,
    '8': 40,
    '9': 44,
    '10': 48,
  },
  borderWidth: {
    '0': 0,
    '100': 1,
    '200': 2,
    '300': 4,
    '400': 6,
    '500': 8,
  },
  borderRadius: {
    '0': 0,
    '100': 4,
    '200': 8,
    '300': 12,
    '400': 16,
    '500': 24,
    '600': 32,
    '700': 8,
    '800': 48,
    '900': 12,
    '1000': 1e5,
  },
  iconSize: {
    xs: 12,
    s: 16,
    m: 20,
    l: 24,
  },
  avatarSize: {
    s: 16,
    m: 24,
    l: 32,
    xl: 40,
    xxl: 64,
    xxxl: 72,
  },
  controlSize: {
    checkboxSize: 16,
    radioSize: 16,
    switchWidth: 44,
    switchHeight: 24,
    switchThumbSize: 22,
    tileSize: 106,
  },
  fontFamilyMono: {
    display1: 'BaseSansMono-Medium',
    display2: 'BaseSansMono-Regular',
    display3: 'BaseSansMono-Medium',
    title1: 'BaseSansMono-Medium',
    title2: 'BaseSansMono-Regular',
    title3: 'BaseSansMono-Medium',
    title4: 'BaseSansMono-Regular',
    headline: 'BaseSansMono-Medium',
    body: 'BaseSansMono-Regular',
    label1: 'BaseSansMono-Medium',
    label2: 'BaseSansMono-Regular',
    caption: 'BaseSansMono-Medium',
    legal: 'BaseSansMono-Regular',
  },
  fontSize: {
    display1: 43,
    display2: 34,
    display3: 30,
    title1: 21,
    title2: 21,
    title3: 17,
    title4: 17,
    headline: 15,
    body: 15,
    label1: 13,
    label2: 13,
    caption: 12,
    legal: 12,
  },
  fontWeight: {
    display1: '600',
    display2: '300',
    display3: '500',
    title1: '500',
    title2: '300',
    title3: '600',
    title4: '300',
    headline: '600',
    body: '400',
    label1: '500',
    label2: '400',
    caption: '600',
    legal: '400',
  },
  lineHeight: {
    display1: 48,
    display2: 40,
    display3: 36,
    title1: 28,
    title2: 28,
    title3: 24,
    title4: 24,
    headline: 20,
    body: 20,
    label1: 16,
    label2: 16,
    caption: 16,
    legal: 16,
  },
  textTransform: {
    display1: 'none',
    display2: 'none',
    display3: 'none',
    title1: 'none',
    title2: 'none',
    title3: 'none',
    title4: 'none',
    headline: 'none',
    body: 'none',
    label1: 'none',
    label2: 'none',
    caption: 'uppercase',
    legal: 'none',
  },
  shadow: {
    elevation1: {
      shadowColor: '#000000',
      shadowOffset: { width: 0, height: 8 },
      shadowOpacity: 0.12,
      shadowRadius: 12,
    },
    elevation2: {
      shadowColor: '#000000',
      shadowOffset: { width: 0, height: 8 },
      shadowOpacity: 0.12,
      shadowRadius: 24,
    },
  },
} as const;
